import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { Platform, Pressable, Text, TextInput, View } from "react-native";
import { VerticalStick } from "./VerticalStick";
import { useOtpInput } from "./useOtpInput";
import { styles } from "./OtpInput.styles";
export const OtpInput = forwardRef((props, ref) => {
    const { models: { text, inputRef, focusedInputIndex }, actions: { clear, handlePress, handleTextChange }, forms: { setText }, } = useOtpInput(props);
    const { id, numberOfDigits, focusColor = "#A4D0A4", focusStickBlinkingDuration, theme = {}, editable = true } = props;
    const { containerStyle, inputsContainerStyle, pinCodeContainerStyle, pinCodeTextStyle, focusStickStyle, } = theme;
    useImperativeHandle(ref, () => ({ clear, setValue: setText }));
    useEffect(() => {
        console.warn("VALUE OF FOCUS COLOR IS", focusColor);
    }, [focusColor]);
    useEffect(() => {
        const autofocusTimeout = setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 200);
        return () => clearTimeout(autofocusTimeout);
    }, []);
    return (React.createElement(View, { style: [styles.container, containerStyle] },
        React.createElement(View, { style: [styles.inputsContainer, inputsContainerStyle] }, Array(numberOfDigits)
            .fill(0)
            .map((_, index) => {
            const char = text[index];
            const isFocusedInput = index === focusedInputIndex;
            return (React.createElement(Pressable, { nativeID: id, key: `${char}-${index}`, onPress: () => handlePress(index), style: [
                    styles.codeContainer,
                    focusColor && isFocusedInput || focusColor === 'red'
                        ? { borderColor: focusColor }
                        : {},
                    pinCodeContainerStyle,
                ] }, isFocusedInput ? (React.createElement(View, { style: styles.otpBox },
                React.createElement(Text, { style: [styles.codeText, pinCodeTextStyle] }, char),
                React.createElement(VerticalStick, { focusColor: focusColor, style: focusStickStyle, focusStickBlinkingDuration: focusStickBlinkingDuration }))) : (React.createElement(Text, { style: [styles.codeText, pinCodeTextStyle] }, char))));
        })),
        React.createElement(TextInput, { value: text, onChangeText: handleTextChange, maxLength: numberOfDigits, ref: inputRef, keyboardType: 'number-pad', autoFocus: Platform.OS === 'web' ? false : true, style: Platform.OS === "web" ? styles.hiddenInput : styles.hiddenInputAndroid, editable: editable, selection: { start: text.length, end: text.length } })));
});
